import getConfig from 'next/config';

import logger from '@sravni/server-utils/lib/logger';
import { createClient } from '@sravni/ugc/lib/client';

import { isServer } from '../../utils/isServer';

const url = isServer ? process.env.DOUBLE_CLICK : getConfig().publicRuntimeConfig.doubleClickUrl;

export const DoubleClickClient = createClient(url, { sentryErrorTagName: 'news-frontend-double-click', logger });
